// extracted by mini-css-extract-plugin
export default {"main_box":"check-password_main_box__-3cjt","fillPassword":"check-password_fillPassword__R2mWJ","formCmg":"check-password_formCmg__M+0Qk"};